module.exports = __webpack_public_path__ + "static/media/9.11d75024.jpg";